// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.partners-title[data-v-1c16febc] {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 40px;\n}\n.partners-title p[data-v-1c16febc] {\n  font-size: 18px !important;\n  font-weight: 600;\n}\n", ""]);
// Exports
module.exports = exports;
